import React, {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import "moment-timezone";
import {useTranslation} from "react-i18next";
import LottoMixNav from "../../lotto/mix/LottoMixNav";
import {currentDate, getDateDef} from "../../../utils/dateUtils";
import {fetchLottoWinLossReport} from "../../../store/lotto/action";
import MainTableWinReport from "../../lotto5/MainTableWinReport";

export default function LottoWinReportMix(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const winReport = useSelector(state => state.lotto.winReport);

    // Local state
    const [lottoType, setLottoType] = useState("LOTTO5");
    const [date, setDate] = useState(currentDate());

    // Initial fetch
    useEffect(() => {
        onFilter();
        // eslint-disable-next-line
    }, []);

    const onFilter = (params = {}) => {
        dispatch(
            fetchLottoWinLossReport({
                ...winReport.filter,
                filterDate: getDateDef(date),
                filterByLotto: lottoType,
                ...params,
            })
        );
    };


    const onChangeLottery = (e) => setLottoType(e.target?.value);

    return (
        <div className="main-w ">
            <div className="main">
                <div className="w-1200">
                    <div className="wrapper-game-content">
                        <LottoMixNav {...props} />
                        <div className="fade-in">
                            <div className="row align-items-center ml-3 mt-2 pb-0">
                                <div className="lottery-type">
                                    <label>{t("labels:common.lotteryType")} :</label>
                                    <select
                                        className="border"
                                        onChange={onChangeLottery}
                                        value={lottoType}
                                    >
                                        <option value="LOTTO5">{t("labels:menus.lotto")} 5</option>
                                        <option value="LOTTO6">{t("labels:menus.lotto")} 6/36</option>
                                        <option value="LOTTO12">{t("labels:menus.lotto")} 12</option>
                                    </select>
                                </div>
                                <div className="form-date-range">
                                    <label>{t("labels:drawing.date")}:</label>
                                </div>
                                <div className="pl-2">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={date}
                                        maxDate={moment().toDate()}
                                        onChange={setDate}
                                        className="form-control bg-white"
                                    />
                                </div>
                                <div className="wrap-btn-filter">
                                    <button
                                        className="btn-game"
                                        onClick={() => onFilter()}
                                    >
                                        {t("labels:common.getResult")}
                                    </button>
                                </div>
                            </div>

                            <MainTableWinReport onChangPage={onFilter} {...winReport}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
